import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import styled from "styled-components";
import { color } from "../templates/ui";
import PaperClip from "../atoms/icons/PaperClip";
import ErrorLabel from "../atoms/ErrorLabel";
import { useTranslation } from "react-i18next";

const getColor = props => {
  if (props.error) {
    return color.error.base;
  }
  if (props.isDragAccept) {
    return props.theme.secondary;
  }
  if (props.isDragReject) {
    return color.error.base;
  }
  if (props.isDragActive) {
    return props.theme.quaternary;
  }
  return "#B2BABF";
};

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
  border-width: 1px;
  border-radius: 7px;
  border-color: ${props => getColor(props)};
  border-style: dashed;
  background-color: ${color.body.base};
  color: ${props => props.theme.tertiary};
  outline: none;
  transition: border 0.24s ease-in-out;
  cursor: pointer;
`;

const Label = styled.label`
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 300;
  color: ${props => props.theme.tertiary};
`;

const StyledPaperClip = styled(PaperClip)`
  width: 19px;
  height: 17px;
  fill: ${props => props.theme.tertiary};
  margin-right: 10px;
`;

const File = styled.div`
  margin: 5px 0;
`;

function FileUploader({ onChange, error }) {
  const onDrop = useCallback(
    acceptedFiles => {
      onChange(acceptedFiles);
    },
    [onChange]
  );
  const { t } = useTranslation();

  const {
    acceptedFiles,
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({ onDrop });

  const files = acceptedFiles.map(file => (
    <File key={file.path}>{file.path}</File>
  ));

  return (
    <>
      <Container
        error={error}
        {...getRootProps({ isDragActive, isDragAccept, isDragReject })}
      >
        <input {...getInputProps()} />
        <Label>
          {files.length > 0 ? (
            <>{files}</>
          ) : (
            <>
              <StyledPaperClip />
              {t("generic.select_file")}
            </>
          )}
        </Label>
        {error && <ErrorLabel>{error}</ErrorLabel>}
      </Container>
    </>
  );
}

export default FileUploader;
